export default __webpack_public_path__ + "static/media/flag-en-JP.4a1c6ff8.png";